import { GenerationDetailsPeriod } from './generation-details-report.interfaces';

export function getTodayDateValue(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatGenerationDetailsDateLabel(dateValue: string): string {
  const parsedDate = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return 'Generation Details';
  }

  const day = String(parsedDate.getDate()).padStart(2, '0');
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const year = String(parsedDate.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
}

export function resolvePeriodForBlockLabel(label: string): GenerationDetailsPeriod {
  const hour = Number.parseInt(label.slice(0, 2), 10);
  if (Number.isNaN(hour) || hour < 8) {
    return 'morning';
  }

  if (hour < 16) {
    return 'day';
  }

  return 'night';
}

